// removed by extract-text-webpack-plugin
module.exports = {"box":"_4k1qashnw4trb5xfyh7khg39ejkeu9mw7zhgfamkx4v8mspu6zn54hpktpx12hfaxzzz3ckrsa49wa1e4136zxe4wp416ufqtk2msh6-styles-module-box","legalCostBox":"mjvmfnrjwvz48ab6r58ad8knb339awabbn42fmsns3bu6vejw2uvusrxb988xansvb2pt11jg3yrx9pzfy3p2a1ueqmb5pdvydezyr-styles-module-legalCostBox","icon":"_23c4f1fded4szg3c296sf536kkfu4yxpcdpgvgjpawm37eebdvst38qa5buvfjs6uh2vckqbtad7t2as7412v1and2w1svdyrdxh69s-styles-module-icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/CollectionCaseEditor/ExpansionPanelPenaltyAndLegalCost/LegalCosts/styles.module.sass
// module id = 519
// module chunks = 0